import { useSelector } from 'react-redux';

const containsProperty = (object, key) => object.hasOwnProperty(key) && object[key] !== null;

export const usePreference = (key, defaultValue) => useSelector((state) => {
  if (state.session.server.forceSettings) {
    if (state.session.server && containsProperty(state.session.server, key)) {
      return state.session.server[key];
    }
    if (state.session.user && containsProperty(state.session.user, key)) {
      return state.session.user[key];
    }
    return defaultValue;
  }
  if (state.session.user && containsProperty(state.session.user, key)) {
    return state.session.user[key];
  }
  if (state.session.server && containsProperty(state.session.server, key)) {
    return state.session.server[key];
  }
  return defaultValue;
});

export const useAttributePreference = (key, defaultValue) => useSelector((state) => {
  if (state.session.server.forceSettings) {
    if (state.session.server && containsProperty(state.session.server.attributes, key)) {
      return state.session.server.attributes[key];
    }
    if (state.session.user && containsProperty(state.session.user.attributes, key)) {
      return state.session.user.attributes[key];
    }
    return defaultValue;
  }
  if (state.session.user && containsProperty(state.session.user.attributes, key)) {
    return state.session.user.attributes[key];
  }
  if (state.session.server && containsProperty(state.session.server.attributes, key)) {
    return state.session.server.attributes[key];
  }
  return defaultValue;
});
